import BaseTheme from './theme-base';

const CustomerTheme = {
    ...BaseTheme,
    headerHeight: '115px',
    modalBackgroundTop: '0',
    navPaddingTopBottom: '0.25rem',
    color: {
        ...BaseTheme.color,
        bgPrimary: 'rgb(247, 250, 255)',
    },
};

export default CustomerTheme;
